<template>
    <h1 class="text-center p-10">Next Week Delivery</h1>
</template>

<script>
export default {
    name: 'NextWeekDelivery',
};
</script>
